module.exports = __webpack_public_path__ + "static/media/RP-B_S_Timeless_Sforza_Orange.d9a7443c.png";